import { BulkUpdateWorkOrderButton } from "./BulkUpdateWorkOrderButton";

export default BulkUpdateWorkOrderButton;
